import { forwardRef, type ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const Input = forwardRef<HTMLInputElement, ComponentProps<'input'>>(
    ({ className, type, value, defaultValue, ...props }, ref) => {
        const isDateInput = type === 'date' || type === 'datetime-local' || type === 'time';
        const hasValue = value !== undefined ? Boolean(value) : Boolean(defaultValue);

        return (
            <input
                ref={ref}
                type={type}
                data-slot="input"
                data-has-value={isDateInput ? hasValue : undefined}
                value={value}
                defaultValue={defaultValue}
                className={cn(
                    'border-input file:text-foreground placeholder:text-foreground/40 selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-background px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                    'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                    className,
                )}
                {...props}
            />
        );
    },
);
Input.displayName = 'Input';

export { Input };
